export default __webpack_public_path__ + "static/media/dashboard-gif.23b06182.gif";